<template>
    <div class="reg-temp-content-area main-content-height p-3">
        <div class="superadmin-dashboard-area">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12" v-if="loaded == false">
                    <loading />
                </div>

                <template v-else>
                    <div class="col-sm-12 col-md-12 col-lg-12" v-if="registered_products.length < 1">
                        <p class="text-center mt-5">You have no registered products with dewhot, please click here yo register your first product.</p>
                        <p class="text-center mt-3">
                            <router-link class="btn btn-primary px-4 py-2" :to="{name: 'CustomerRegisteredProductsAdd'}">
                                <i class="fa fa-plus"></i> Add New Product
                            </router-link>
                        </p>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-12" v-if="registered_products.length > 0">
                        <p class="text-left">
                            <router-link class="btn btn-primary px-4 py-2" :to="{name: 'CustomerRegisteredProductsAdd'}">
                                <i class="fa fa-plus"></i> &nbsp; Add New Product
                            </router-link>
                        </p>
                    </div>

                    <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3" v-bind:key="'product_' + index" v-for="(product, index) in registered_products">
                        <div class="card mb-4">
                            <div class="card-body">
                                <div class="registered-product-item excerpt-card">
                                    <div class="product-item-head customer">
                                        <TicketIcon :ticket_status="product.ticket_status" :ticket_type="product.ticket_type" />
                                        <router-link
                                            class="btn btn-primary card-view"
                                            :to="{name: 'CustomerRegisteredProductEdit', params: {id: product.id}}"
                                        >
                                            VIEW
                                        </router-link>
                                    </div>

                                    <ul>
                                        <li>
                                            <span class="semibold">Model:</span> <span class="normal truncate">{{ product.product_model }}</span>
                                        </li>
                                        <li>
                                            <span class="semibold">Serial number:</span>
                                            <span class="normal">{{ product.sku_with_serial_number }}</span>
                                        </li>
                                        <li>
                                            <span class="semibold">Date purchased:</span>
                                            <span class="normal">{{ readAbleDate(product.installation_date) }}</span>
                                        </li>
                                        <li>
                                            <span class="semibold">Place of purchase:</span>
                                            <span class="normal">{{ product.place_of_purchase }}</span>
                                        </li>
                                        <li>
                                            <span class="semibold">Coc number:</span>
                                            <span class="normal"> {{ product.coc_number ? product.coc_number : '-n/a-' }} </span>
                                        </li>
                                        <li>
                                            <span class="semibold">Coc certificate:</span>

                                            <span class="normal has-file" v-if="product.coc_certificate">
                                                <i class="fas fa-file-pdf"></i>
                                            </span>
                                            <span class="normal" v-else>--n/a--</span>
                                        </li>
                                        <li>
                                            <span class="semibold">Purchased from:</span>
                                            <span class="normal"> {{ product.purchased_from ? product.purchased_from.company : '---' }} </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import {mapGetters, mapActions} from 'vuex';
import moment from 'moment';
import TicketIcon from '@/components/TicketIcon.vue';
export default {
    name: 'registerProductCustomer',
    components: {
        TicketIcon
    },
    data() {
        return {
            loaded: true,
            currentPage: 1,
            pageNavs: [],
            registered_products: []
        };
    },

    computed: {
        ...mapGetters({
            vg_registered_products: 'customer_reg_products/list',
            vg_loggedIn_user_id: 'auth/userid'
        })
    },

    mounted() {
        this.fetchRegProducts();
    },

    methods: {
        /**
         * Fetch reg products
         */
        async fetchRegProducts() {
            this.loaded = false;
            const url = `${Env.baseUrl}/customer/reg-product/all?page=${this.currentPage}`;
            AuthApis.getApi(url)
                .then(async (res) => {
                    this.registered_products = res.data.payload;
                    this.pageNavs = res.data.nav;
                    this.loaded = true;
                })
                .catch((err) => {
                    console.log(err);
                    this.loaded = true;
                });
        },

        /**
         * Fetch page data
         */
        fetchPage(pageNo) {
            this.currentPage = pageNo;
            this.fetchRegProducts();
        },

        /**
         * Delete product
         */
        deleteThis(product) {
            this.$confirm({
                title: `DELETE?`,
                message: 'Are you sure you want to delete ' + product.sku_with_serial_number,
                button: {
                    no: 'No',
                    yes: 'Yes'
                },
                callback: (confirm) => {
                    if (confirm) {
                        const url = `${Env.baseUrl}/customer/reg-product/delete/${product.id}`;
                        AuthApis.deleteApi(url)
                            .then(async (res) => {
                                this.fetchRegProducts();
                                this.$toasted.global.success({
                                    message: 'Successfully deleted.'
                                });
                            })
                            .catch((err) => {
                                this.$toasted.global.error({
                                    message: 'Failed, please try again later.'
                                });
                            });
                    }
                }
            });
        },

        viewCocCertificate(obj) {
            this.va_pdfModal(true);
            this.va_pdfModalObj(obj);
        },

        readAbleDate(dateSring) {
            return dateSring ? moment(dateSring).format('DD-MM-YYYY') : '';
        },

        ...mapActions({
            va_setRegProducts: 'customer_reg_products/setList',
            va_pdfModal: 'pdf/setActive',
            va_pdfModalObj: 'pdf/setActiveObj'
        })
    }
};
</script>
